import { IOrganization, IUser, Modify, UUID } from "src/app/core/interfaces";
import { OrganizationStateObject } from "./organization-model";

export interface IOrganizationStateModel extends IOrganization {
  id: UUID;
}

export interface SecureProStateModel {
  org: OrganizationStateObject;
  orgUsers: Modify<IUser, { id: UUID }>[]; // List of users in the user's org,
  isEntityLoading: boolean;
  isEntityOwnersLoading: boolean;
  isEntityProgressLoading: boolean;
  isEntityTransferring: boolean;
}

export const defaultSecureProState: SecureProStateModel = {
  org: new OrganizationStateObject({
    id: "",
    name: "",
    groups: {},
    entities: {},
    roles: {},
  }),
  orgUsers: [],
  isEntityLoading: false,
  isEntityOwnersLoading: false,
  isEntityProgressLoading: false,
  isEntityTransferring: false,
};
